import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { PersonaCollection } from '@sdk/personaCollection/types/PersonaCollection';
import { UserFromApi } from '@sdk/users/types/UserFromApi';
import { ObjectWithId } from '@sdk/common/types/ObjectWithId';
import { User } from '@sdk/users/types/User';

import { getPersonaFromAPI } from '@web/common/utils/getPersonaFromAPI';

export const getPersonasListFromApi = (
  personas: (UserFromApi | ObjectWithId)[],
  personaCollection: PersonaCollection,
  currentUser: AuthUserType
): User[] => personas.map((persona) => getPersonaFromAPI(persona, personaCollection, currentUser));
